import React, { PureComponent } from 'react';

export default class DependenciesHeader extends PureComponent {
  static propTypes = {
    // TODO
  }

  render() {
    const { interestingDeps, firstColWidth } = this.props;

    return (
      <div className="row table-row" style={{ fontWeight: 'bold', marginTop: '20px' }}>
        <div className={`col-${firstColWidth}`}>Component</div>
        {
          interestingDeps.map(dep => (
            <div key={dep.package} className="col-1">{dep.package}</div>
          ))
        }
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/DependenciesPage/DependenciesHeader.jsx